import vaultallComponent from './vault.all.component';

let vaultallModule = angular.module('vaultall', [
	])

	.component('vaultall', vaultallComponent)

	.name;

export default vaultallModule;


// WEBPACK FOOTER //
// ./client/app/components/vault/all/index.js